import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";

export const fetchData = async () => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/dashboard-data`,
  );
  return response;
};
